module.exports = __webpack_public_path__ + "assets/images/account.ab4c8247.svg";